
import Vue from 'vue';
import Component from 'vue-class-component';

import PeekPortrait from '@/components/PeekPortrait.vue';

@Component({
    components: {
        PeekPortrait
    }
}) 
export default class Me extends Vue {
}
